// App.js
import React from "react";
import "./App.css";

function App() {
  const webApps = [
    { name: "Approved Worker App", 
      url: "https://approved-worker.herokuapp.com/",
      description: "App for managing and approving worker profiles. App is built on using React, Django and MYSQL. Deployed in Heroku Cloud."
     },
    { name: "Monitoring Control Asset Register App",
      url: "https://mcsasset-app.herokuapp.com/",
      description: "Register for tracking control system related assets installed on site.  App is built on uisng React, Django and MYSQL. Deployed in Heroku Cloud."
     },
    { name: "Job Tracking App", 
      url: "https://demo-job-app.herokuapp.com/",
      description: "Simple job application and tracking system demo. App is built on using React, Nodejs and MongoDB. Deployed in Heroku Cloud."
     },
     { name: "Online Shopping App",
      url: "https://django-shopapp.herokuapp.com/",
      description: "Demo Online Shopping App.  App is built on uisng React, Django and MYSQL. Deployed in Heroku and AWS Cloud."
     },
    { name: "Demo Simple Chat App.", 
      url: "https://jnybrahma-chat-app-deploy.herokuapp.com/",
      description: "Demo Chat App.  App is built on using simple NodeJs express. Deployed in Heroku Cloud."
    },
    { name: "First Demo Weather App", 
      url: "https://jnybrahma-weather-app.herokuapp.com/",
      description: "Simple demo weather app. App is built on using simple NodeJs, Weatherstack and Mapbox api. Deployed in Heroku Cloud."
    },
    { name: "Demo Keyboard Game", 
      url: "https://demo-keyboard-game.netlify.app/",
      description: "Keyboard game App is built on using React, Netlify Serverless function, Airtable and use auth0 for authorisation. Deployed in Netlify Cloud."
    },
    { name: "Demo Canada Population Dashboard", 
      url: "https://canada-population-dashboard-emj4.onrender.com/",
      description: "Demo Population dashboard app build on streamlit and deployed on Render"
    },
    { name: "Demo Car Parts Sales Forecasting", 
      url: "https://car-parts-monthly-sales-forcast.onrender.com/",
      description: "Demo car parts sales forecasting app build on streamlit connect to supabase (database) and deployed on Render"
    },
    /* { name: "Demo Machine Learning Model App using image classifier", 
      url: "http://134.199.153.203/",
      description: "Demonstrates image classification using a trained ML model in AWS Sagemaker AI. App is built on using React, Nodejs and MongoDB. Deployed on DigitialOcean VM"
    },*/
    { name: "Personal Blog App", 
      url: "https://personal-blog-django-4guj.onrender.com/",
      description: "Personal Blog app. App is built on using simple Django, HTML and MySQL. Deployed in Render and AWS Cloud."
    },

  ];

  return (
    <div className="app">
      <header className="header">
        <h1>Keep Learning Anytime, Anywhere and Grow Your Knowledge </h1>
      </header>

      <main className="main fade-in-up">
        <h2>Explore Demo Web Apps</h2>
        <ul className="link-list">
          {webApps.map((app, index) => (
            
            <li key={index} className='app-box'>
              <p className="description"><h5>{app.description}</h5></p>
              <button onClick={() => window.open(app.url, '_blank')} className="app-button">
              <h4>{app.name}</h4>
              </button>
              
            </li>
          ))}
        </ul>
      </main>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Demo Web Apps by J Brahma</p>
      </footer>
    </div>
  );
}

export default App;
